import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useProjectUIContext } from "../ProjectUIContext";
import { ProjectDeleteDialogHeader } from "./ProjectDialogHeader";
import { ProjectDeleteForm } from "./ProjectDeleteForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/project/projectAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const ProjectDeleteDialog = ({ id, show, onHide }) => {
  // Project UI Context
  const projectUIContext = useProjectUIContext();
  const projectUIProps = useMemo(() => {
    return {
      initProject: projectUIContext.initProject,
      queryParams: projectUIContext.queryParams,
      setQueryParams: projectUIContext.setQueryParams,
    };
  }, [projectUIContext]);

  // Project Redux state
  const dispatch = useDispatch();
  const { actionsLoading, projectForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.project.actionsLoading,
      projectForEdit: state.project.projectForEdit,
      error: state.project.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting Project by id
    dispatch(actions.fetchProject(id));
  }, [id, dispatch]);

  const deleteProject = () => {
    dispatch(actions.deleteProject(id)).then((response) => {
      toast.success(response.message, toastOption);
      dispatch(actions.fetchProjects(projectUIProps.queryParams)).then(() =>
        onHide()
      );
    });
  };

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="modal-sizes-title-lg">
      <ProjectDeleteDialogHeader id={id} />
      <ProjectDeleteForm
        deleteProject={deleteProject}
        actionsLoading={actionsLoading}
        project={projectForEdit || projectUIProps.initProject}
        onHide={onHide}
      />
    </Modal>
  );
};
